import CollapsibleGroupRoot from './component/collapsible-root'
import CollapsibleGroupItem from './component/collapsible-item'

const CollapsibleGroupComponent = {
  Root: CollapsibleGroupRoot,
  Item: CollapsibleGroupItem
}

export default CollapsibleGroupComponent
